import { createContext, useContext, useEffect, useState } from 'react';
import { authApi } from '../api/auth.js';
import { getToken, setToken } from '../api/client.js';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [workspace, setWorkspace] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!getToken()) {
      setLoading(false);
      return;
    }
    authApi
      .me()
      .then((data) => {
        if (cancelled) return;
        setUser(data.user);
        setWorkspace(data.workspace);
      })
      .catch(() => {
        setToken(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  async function login(email, password) {
    const data = await authApi.login({ email, password });
    setToken(data.token);
    setUser(data.user);
    setWorkspace(data.workspace);
    return data;
  }

  async function register(payload) {
    const data = await authApi.register(payload);
    setToken(data.token);
    setUser(data.user);
    setWorkspace(data.workspace);
    return data;
  }

  async function logout() {
    try {
      await authApi.logout();
    } catch {
      // ignore
    }
    setToken(null);
    setUser(null);
    setWorkspace(null);
  }

  return (
    <AuthContext.Provider
      value={{ user, workspace, setWorkspace, loading, login, register, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}
